import React, { useEffect } from "react";
import PageShell from "../components/PageShell";
import { setMeta } from "../lib/seo";

export default function Terms() {
  useEffect(() => {
    setMeta({
      title: "Terms of Service — Culinera",
      description:
        "The terms for using culinera.ca: the service we provide, accuracy of listings, acceptable use, content ownership, and liability. Questions: hello@culinera.ca.",
      canonical: "https://culinera.ca/terms",
    });
  }, []);

  return (
    <PageShell testid="terms-page">
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">Terms of Service</h1>
        <p className="text-sm text-gray-500 mb-6">Last updated: November 3, 2026</p>
        <p className="text-gray-700 mb-6">
          By using culinera.ca, you agree to these terms. If you do not agree, please do not use the site.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">The service</h2>
        <p className="text-gray-700 mb-4">
          Culinera provides Alberta restaurant listings, food guides, and a trip-planning tool that generates
          personalized food itineraries. The free plan includes 3 personalized itineraries. Paid plans, if offered, are
          described on the pricing page, which governs over any summary here.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">Accuracy</h2>
        <p className="text-gray-700 mb-4">
          We work to keep listings accurate, but restaurants change hours, menus, prices, and locations without notice,
          and some listings are based on public information rather than a visit. Treat listings as a starting point and
          confirm details with the restaurant before you travel. Culinera is not responsible for a restaurant's food,
          service, prices, or availability.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">Your use</h2>
        <p className="text-gray-700 mb-4">
          You agree not to scrape the directory in bulk, copy guides or itineraries for republication without permission,
          or use the site in a way that disrupts it or breaks the law. You may share links to our pages and quote short
          excerpts with attribution.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">Content ownership</h2>
        <p className="text-gray-700 mb-4">
          Guides, itineraries, and site design are Culinera's content and may not be reproduced in full without
          permission. Restaurant names, trademarks, and photos belong to their respective owners.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">Liability</h2>
        <p className="text-gray-700 mb-4">
          The site and its content are provided "as is", without warranties of any kind. To the fullest extent allowed
          by law, Culinera is not liable for any loss arising from your use of the site, a listing's inaccuracy, or a
          third party's services.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">Changes and contact</h2>
        <p className="text-gray-700 mb-4">
          We may update these terms; the updated version posted here applies from its date. Questions:{" "}
          <a className="text-teal-600 hover:underline" href="mailto:hello@culinera.ca">hello@culinera.ca</a>. These terms
          are governed by the laws of Alberta and Canada.
        </p>
      </article>
    </PageShell>
  );
}
